import { useCallback } from 'react';
import { useLogMarketAnalyticsEvent } from '../../../hooks/useLogMarketAnalyticsEvent';

export const useLogClickCouponList = () => {
  const logMarketAnalytics = useLogMarketAnalyticsEvent();

  return useCallback(() => {
    logMarketAnalytics({
      name: 'CLICK_COUPON_LIST',
    });
  }, [logMarketAnalytics]);
};
